declare global {
   interface Window {
      ym?: any;
   }
}

export const ym = (...args: any[]) => {
   if (typeof window !== 'undefined' && window.ym) {
      window.ym(...args);
   }
};


